import { z } from 'zod'
import { oc } from '@orpc/contract'
import { RecipientInputSchema } from './referral-discovery-views.schema'

// Adds a recipient to Frequently used without a referral (the Clinics and Doctors tabs'
// "save" action). The order flow sends the same shape a fax send records.
export const referralDiscoveryRememberInputSchema = RecipientInputSchema

export const referralDiscoveryRemember = oc
  .route({ method: 'POST', path: '/v2/referral-discovery/remember' })
  .input(referralDiscoveryRememberInputSchema)
  .output(z.object({ key: z.string() }))
